import { getFontSizePixelValue, getViewWidthPixelValue, getViewHeightPixelValue, converterMap } from './internal';
export * from './defs';
var UNIT_SPLIT_REGEXP = /^((?:[1-9]\d*|0)(?:\.\d+)?)(px|cm|mm|Q|in|pc|pt|rem|em|vw|vh|vmin|vmax|%|)$/;
export var splitUnitValue = function (value) {
    var split = value.match(UNIT_SPLIT_REGEXP);
    if (split === null || split.length < 3) {
        throw new TypeError('Invalid value for value argument.');
    }
    return {
        value: parseFloat(split[1]),
        unitSuffix: split[2],
    };
};
var defaultOptions = {
    rem: 16,
    em: 16,
    viewHeight: 1920,
    viewWidth: 1080,
};
export var convertUnits = function (fromUnitValue, toUnitSuffix, options) {
    var _a;
    var _b = (_a = splitUnitValue(fromUnitValue)) !== null && _a !== void 0 ? _a : {}, fromValue = _b.value, fromUnitSuffix = _b.unitSuffix;
    var converters = converterMap[fromUnitSuffix];
    if (converters === undefined) {
        throw new TypeError('Invalid value for fromUnitValue argument.');
    }
    var converter = converters[toUnitSuffix];
    if (converter === undefined) {
        throw new TypeError('Invalid value for toUnitSuffix argument');
    }
    var toUnitValue = converter(fromValue, {
        remPixelValue: function () {
            var remPixel = typeof (options === null || options === void 0 ? void 0 : options.rem) === 'string' ? splitUnitValue(options === null || options === void 0 ? void 0 : options.rem) : undefined;
            var remElement = typeof (options === null || options === void 0 ? void 0 : options.rem) === 'object' ? options === null || options === void 0 ? void 0 : options.rem : undefined;
            var remPixelValue = remPixel ? remPixel.value : getFontSizePixelValue(remElement);
            return remPixelValue !== null && remPixelValue !== void 0 ? remPixelValue : defaultOptions.rem;
        },
        emPixelValue: function () {
            var emPixel = typeof (options === null || options === void 0 ? void 0 : options.em) === 'string' ? splitUnitValue(options === null || options === void 0 ? void 0 : options.em) : undefined;
            var emElement = typeof (options === null || options === void 0 ? void 0 : options.em) === 'object' ? options === null || options === void 0 ? void 0 : options.em : undefined;
            var emPixelValue = emPixel ? emPixel.value : getFontSizePixelValue(emElement);
            return emPixelValue !== null && emPixelValue !== void 0 ? emPixelValue : defaultOptions.em;
        },
        viewWidthPixelValue: function () {
            var _a;
            var viewWidthPixelValue = (_a = options === null || options === void 0 ? void 0 : options.viewWidth) !== null && _a !== void 0 ? _a : getViewWidthPixelValue();
            return viewWidthPixelValue !== null && viewWidthPixelValue !== void 0 ? viewWidthPixelValue : defaultOptions.viewWidth;
        },
        viewHeightPixelValue: function () {
            var _a;
            var viewHeightPixelValue = (_a = options === null || options === void 0 ? void 0 : options.viewHeight) !== null && _a !== void 0 ? _a : getViewHeightPixelValue();
            return viewHeightPixelValue !== null && viewHeightPixelValue !== void 0 ? viewHeightPixelValue : defaultOptions.viewHeight;
        },
    });
    return "" + toUnitValue + toUnitSuffix;
};
//# sourceMappingURL=index.js.map